import React from "react";
import JobHistoryComponent from "../../components/Jobs/JobHistoryComponent";

const JobHistory: React.FC = () => {
  return <JobHistoryComponent />;
};

export default JobHistory;
